import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col, Form, Button, Table, Modal } from "react-bootstrap";

const AdminSuccessStories = () => {
  const [stories, setStories] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    role: "",
    desc: "",
    image: null,
  });
  const [editId, setEditId] = useState(null);

  // Fetch existing stories
  const fetchStories = async () => {
    try {
      const response = await axios.get("https://api.biznetusa.com/api/all-stories");
      if (response.data.status === 200) {
        setStories(response.data.success_stories);
        setImagePath(response.data.imagePath);
      }
    } catch (error) {
      console.error("Error fetching stories:", error);
    }
  };

  useEffect(() => {
    fetchStories();
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("role", formData.role);
    formDataToSend.append("desc", formData.desc);
    if (formData.image) {
      formDataToSend.append("image", formData.image);
    }

    try {
      if (editId) {
        // Update API
        await axios.put(`https://api.biznetusa.com/api/update-stories/${editId}`, formDataToSend);
      } else {
        // Add API
        await axios.post("https://api.biznetusa.com/api/store-stories", formDataToSend);
      }
      fetchStories();
      setFormData({ name: "", role: "", desc: "", image: null });
      setEditId(null);
      setShowModal(false);
    } catch (error) {
      console.error("Error saving story:", error);
    }
  };

  // Handle delete
  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://api.biznetusa.com/api/deletestories/${id}`);
      fetchStories();
    } catch (error) {
      console.error("Error deleting story:", error);
    }
  };

  // Handle Edit
  const handleEdit = (story) => {
    setEditId(story.id);
    setFormData({
      name: story.name,
      role: story.role,
      desc: story.desc,
      image: null,
    });
    setShowModal(true);
  };

  return (
    <Container className="py-4">
      <h2 className="text-center mb-4">Success Stories Management</h2>
      <Button variant="primary" className="mb-3" onClick={() => setShowModal(true)}>
        Add Success Story
      </Button>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Role</th>
            <th>Description</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {stories.map((story, index) => (
            <tr key={story.id}>
              <td>{index + 1}</td>
              <td>{story.name}</td>
              <td>{story.role}</td>
              <td>{story.desc}</td>
              <td>
                <img
                  src={`${imagePath}/${story.image}`}
                  alt={story.name}
                  style={{ width: "80px", height: "auto" }}
                />
              </td>
              <td>
                <Button variant="info" className="me-2" onClick={() => handleEdit(story)}>
                  Edit
                </Button>
                <Button variant="danger" onClick={() => handleDelete(story.id)}>
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal for Adding/Editing */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editId ? "Edit Success Story" : "Add Success Story"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Role</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter role"
                value={formData.role}
                onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter description"
                value={formData.desc}
                onChange={(e) => setFormData({ ...formData, desc: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Image</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              {editId ? "Update" : "Add"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default AdminSuccessStories;
